<div [formGroup]="formGroup">
  <h1>Share Action Item</h1>
  <div>
    <mat-form-field>
      <mat-label>Category</mat-label>
      <mat-select
                  value="Unexisting"
                  (selectionChange)="formGroup.controls.category.setValue($event.value)"
      >
        <mat-select-trigger style="display: inline-block;">
          <input
            formControlName="category"
            (click)="$event.stopPropagation()"
          >
        </mat-select-trigger>
        <mat-option [value]="'Unexisting'" style="display:none"></mat-option>
        <mat-option *ngFor="let category of categories" [value]="category">{{category}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput  formControlName="name"/>
    </mat-form-field>
  </div>
  <div>
    <mat-slide-toggle
      class="example-margin"
      name="typeBool"
      formControlName="isGlobal"
    >
      Global
    </mat-slide-toggle>
  </div>
</div>
<div style="display: flex; flex-direction: row; gap: 30px; margin-top: 10px; justify-content: center; align-items: center">
  <button mat-raised-button (click)="onClose(true)">Save</button>
  <button mat-raised-button (click)="onClose(false)">Cancel</button>
</div>
